module.exports = __webpack_public_path__ + "img/admin-portal-logo.7174010e.png";